// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FontsList-modulewrapper16k"};